import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-[#57af4e] p-6 plex-regular"
}
const _hoisted_2 = { class: "container mx-auto max-w-7xl bg-white bg-opacity-85 rounded-lg p-6" }
const _hoisted_3 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2" }
const _hoisted_4 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_7 = { class: "text-sm text-red-500 p-error" }
const _hoisted_8 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2" }
const _hoisted_9 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_10 = { class: "text-sm text-red-500 p-error" }
const _hoisted_11 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_12 = { class: "text-sm text-red-500 p-error" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_15 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_16 = { class: "text-sm text-red-500 p-error" }
const _hoisted_17 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_18 = { class: "text-sm text-red-500 p-error" }
const _hoisted_19 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_20 = { class: "text-sm text-red-500 p-error" }
const _hoisted_21 = { class: "mt-4" }
const _hoisted_22 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_25 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schema,
      class: "space-y-4 text-gray-700",
      onInvalidSubmit: _ctx.onInvalidSubmit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "w-full py-6" }, [
            _createElementVNode("h1", { class: "plex-semibold text-xl text-gray-800" }, "INSTITUCIONES"),
            _createElementVNode("h1", { class: "plex-semibold text-gray-800" }, "Por favor complete el formulario en su totalidad")
          ], -1)),
          _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "plex-semibold mt-5 w-full bg-white bg-opacity-55 p-2 rounded-lg border border-green-100" }, "Coordinador ", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "block mb-1" }, "Documento", -1)),
              _createVNode(_component_Field, {
                name: "dni",
                modelValue: _ctx.formData.dni,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                    placeholder: "Documento"
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_ErrorMessage, { name: "dni" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block mb-1" }, "Empresa / Institución", -1)),
              _createVNode(_component_Field, {
                name: "empresa",
                modelValue: _ctx.formData.empresa,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.empresa) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                    placeholder: "Empresa / Institución"
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_ErrorMessage, { name: "empresa" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)),
              _createVNode(_component_Field, {
                name: "nombre",
                modelValue: _ctx.formData.nombre,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.nombre) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                    placeholder: "Nombre"
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_ErrorMessage, { name: "nombre" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)),
              _createVNode(_component_Field, {
                name: "apellido",
                modelValue: _ctx.formData.apellido,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.apellido) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                    placeholder: "Apellido"
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_ErrorMessage, { name: "apellido" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "plex-semibold mt-5 w-full bg-white bg-opacity-55 p-2 rounded-lg border border-green-100" }, "Integrantes ", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.alumnos, (alumno, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "p-4 border rounded-lg mt-3 bg-gray-50 relative shadow-lg"
            }, [
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (_ctx.removeAlumno(index)),
                class: "absolute top-2 right-2 text-red-600 hover:text-red-800 font-bold"
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "pi pi-times" }, null, -1)
              ]))], 8, _hoisted_13),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block mb-1" }, "Documento", -1)),
                  _createVNode(_component_Field, {
                    name: `alumnos[${index}].dni`,
                    modelValue: alumno.dni,
                    "onUpdate:modelValue": ($event: any) => ((alumno.dni) = $event)
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps({ ref_for: true }, field, {
                        type: "text",
                        class: ["input-base", { 'bg-white': true, 'input-error': errors.length > 0 }],
                        placeholder: "Documento"
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, {
                          name: `alumnos[${index}].dni`
                        }, null, 8, ["name"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["name", "modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)),
                  _createVNode(_component_Field, {
                    name: `alumnos[${index}].nombre`,
                    modelValue: alumno.nombre,
                    "onUpdate:modelValue": ($event: any) => ((alumno.nombre) = $event)
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps({ ref_for: true }, field, {
                        type: "text",
                        class: ["input-base", { 'bg-white': true, 'input-error': errors.length > 0 }],
                        placeholder: "Nombre"
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_18, [
                        _createVNode(_component_ErrorMessage, {
                          name: `alumnos[${index}].nombre`
                        }, null, 8, ["name"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["name", "modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)),
                  _createVNode(_component_Field, {
                    name: `alumnos[${index}].apellido`,
                    modelValue: alumno.apellido,
                    "onUpdate:modelValue": ($event: any) => ((alumno.apellido) = $event)
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps({ ref_for: true }, field, {
                        type: "text",
                        class: ["input-base", { 'bg-white': true, 'input-error': errors.length > 0 }],
                        placeholder: "Apellido"
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_20, [
                        _createVNode(_component_ErrorMessage, {
                          name: `alumnos[${index}].apellido`
                        }, null, 8, ["name"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["name", "modelValue", "onUpdate:modelValue"])
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addAlumno && _ctx.addAlumno(...args))),
              class: "px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            }, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("i", { class: "pi pi-plus mr-2" }, null, -1),
              _createTextVNode(" AGREGAR INTEGRANTE ", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              type: "submit",
              class: "mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
              disabled: _ctx.isSubmitting
            }, [
              _withDirectives(_createElementVNode("i", _hoisted_24, null, 512), [
                [_vShow, _ctx.isSubmitting]
              ]),
              _withDirectives(_createElementVNode("i", _hoisted_25, null, 512), [
                [_vShow, !_ctx.isSubmitting]
              ]),
              _cache[14] || (_cache[14] = _createTextVNode(" REGISTRARME ", -1))
            ], 8, _hoisted_23)
          ])
        ]),
        _createVNode(_component_BlockUI, {
          blocked: _ctx.isSubmitting,
          fullScreen: ""
        }, null, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"])
  ]))
}